<div class="flex flex-col gap-{{ gap }}">
  <ui-headline
    [type]="labelType"
    [mobile-type]="labelType"
    font-weight="semibold"
    [text-color]="labelColor"
  >
    {{ label }}
  </ui-headline>
  <ng-content />
</div>
